export default __webpack_public_path__ + "static/media/SK.cc754fc5.png";